var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"root d-inline-block"},[_c('router-link',{staticClass:"btn btn-success",attrs:{"to":'/user-accesses/' + _vm.row.id}},[_vm._v("دسترسی ها")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }